import { render, staticRenderFns } from "./myAnswer.vue?vue&type=template&id=6a4787f4&scoped=true"
import script from "./myAnswer.vue?vue&type=script&lang=js"
export * from "./myAnswer.vue?vue&type=script&lang=js"
import style0 from "./myAnswer.vue?vue&type=style&index=0&id=6a4787f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4787f4",
  null
  
)

export default component.exports